import { Chips, LinkButton, Switch, TDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { ALL_VAS } from 'shared/constants/vas';
import { MY_OFFERS } from 'shared/constants/links';

interface IMoreEffectiveProps {
  onChangeService: (serviceId: number) => void;
  onChangePinActive: (value: boolean) => void;
  pinIsActive: boolean;
  activeVas: number;
  device: TDeviceType;
}

export const MoreEffective: React.FC<IMoreEffectiveProps> = ({
  onChangeService,
  onChangePinActive,
  pinIsActive,
  activeVas,
  device,
}) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title-container']}>
        <div className={styles['title']}>Больше эффективности за те же деньги</div>
      </div>
      <div className={styles['animated-container']}>
        <div className={styles['offers-block']}>
          <div className={styles['textblock']}>
            <div className={styles['text']}>
              Чем&nbsp;сильнее продвижение, тем&nbsp;чаще показываем ваше объявление на&nbsp;первых позициях
              в&nbsp;рекомендациях клиентам, которые интересовались похожими объектами
            </div>
            <div>
              <Chips
                selectType="oneOf"
                value={[activeVas]}
                onChipClick={e => onChangeService(e)}
                options={ALL_VAS.map(item => ({ value: item.vasId, label: item.title }))}
              />
            </div>
          </div>
          <div className={styles['phone-offers-container']}>
            <div className={styles['phone-offer']}>
              <div data-name="phoneOffer" className={clsx(styles['offer'], styles['first-offer'])} />
              <div data-name="phoneOffer" className={clsx(styles['offer'], styles['second-offer'])} />
              <div data-name="phoneOffer" className={clsx(styles['offer'], styles['third-offer'])} />
              <div data-name="phoneOffer" className={clsx(styles['offer'], styles['main-offer'])} />
            </div>
          </div>
        </div>
        <div className={styles['map-block']}>
          <div className={styles['phone-map-container']}>
            <div className={styles['phone-map-wrapper']}>
              <div className={styles['phone-map']}>
                <div
                  className={clsx(styles['pin'], styles['first'], 'animate-pin', pinIsActive && styles['active-pin'])}
                />
                <div className={clsx(styles['pin-details'], styles['first'], pinIsActive && styles['active'])}>
                  <div className={styles['notice']}>С мебелью</div>
                  <div className={styles['price']}>22 млн</div>
                </div>

                <div
                  className={clsx(styles['pin'], styles['second'], 'animate-pin', pinIsActive && styles['active-pin'])}
                />
                <div
                  className={clsx(
                    styles['pin-details'],
                    styles['second'],
                    styles['left'],
                    pinIsActive && styles['active'],
                  )}
                >
                  <div className={styles['notice']}>Хорошая цена</div>
                  <div className={styles['pin-details-container']}>
                    <div className={styles['price']}>16 млн</div>
                    <div className={styles['details']}>2 ком. ･ 60,7 м² ･ 8/17 эт.</div>
                  </div>
                </div>
                <div
                  className={clsx(styles['pin'], styles['third'], 'animate-pin', pinIsActive && styles['active-pin'])}
                />
                <div className={clsx(styles['pin-details'], styles['third'], pinIsActive && styles['active'])}>
                  <div className={styles['notice']}>Только на Циан</div>
                  <div className={styles['price']}>12 млн</div>
                </div>
              </div>
            </div>
            <div className={styles['map-notice']}>
              В категориях долгосрочной аренды и продажи городской и загородной недвижимости на всех платформах, в
              категориях аренды и продажи коммерческой недвижимости в мобильном приложении
            </div>
          </div>
          <div className={clsx(styles['textblock'], styles['map-textblock'])}>
            <div className={styles['text']}>
              Получайте больше просмотров за&nbsp;счет выделения на&nbsp;карте с&nbsp;продвижением Топ и&nbsp;Топ +
              Ставка
            </div>
            <ul className={clsx(styles['textblock-list'], styles['text'])}>
              <li>Пин объекта подсвечивается и пульсирует</li>
              <li>Комнатность, этаж, площадь — прямо на карте</li>
              <li>Виден один из значков объекта</li>
            </ul>
            <div className={styles['textblock-chips']}>
              <div className={styles['chip']}>Хорошая цена</div>
              <div className={styles['chip']}>Только на Циан</div>
              <div className={styles['chip']}>С мебелью</div>
              <div className={styles['chip']}>Проверено в Росреестре</div>
            </div>
            <div className={styles['switcher']}>
              <Switch
                label={<span className={styles['switcher-text']}>Попробовать</span>}
                onChange={e => onChangePinActive(e.currentTarget.checked)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles['btn-container']}>
        <LinkButton href={MY_OFFERS} target="_blank" size={device === 'desktop' ? 'L' : 'M'} fullWidth>
          Подключить
        </LinkButton>
      </div>
      <div className={styles['more-opportunites']}>
        <div className={styles['more-textblock']}>
          <div className={styles['more-title']}>Еще больше возможностей с автостратегиями</div>
          <div className={styles['more-description']}>Автоматизируйте управление продвижением на Циан</div>
        </div>
        <div className={styles['more-info']}>
          <div className={styles['more-image']} />
          <div className={styles['more-list']}>
            <ul className={styles['list']}>
              <li>
                Стратегии 1 место / 1 страница теперь используют только продвижение Топ + Ставка - так объявление
                получает фиксированную позицию в поиске, а также максимальную эффективность в рекомендациях и
                продвижение на карте
              </li>
              <li>Подключают продвижение к объектам, которые получат больше просмотров и откликов</li>
            </ul>
            <div className={styles['more-btns']}>
              <div className={styles['more-btn']}>
                <LinkButton href={MY_OFFERS} target="_blank" size={device === 'desktop' ? 'L' : 'M'} fullWidth>
                  Подключить
                </LinkButton>
              </div>
              <div className={styles['more-btn']}>
                <LinkButton
                  target="_blank"
                  href="https://support.cian.ru/ru/knowledge_base/art/105/cat/20/avtostrategii"
                  size={device === 'desktop' ? 'L' : 'M'}
                  fullWidth
                >
                  Узнать больше
                </LinkButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
